import React, { useEffect, useState } from 'react';
import useToken from '../../useToken'
import { useSelector, useDispatch } from 'react-redux';
import { fetchAll } from '../../features/harvest_report/harvestAllReportSlice';
import { endOfMonth, startOfMonth, subYears, subMonths, format } from "date-fns";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  title: {
    marginLeft: 10,
  },
});

const Harvest = () => {
    const classes = useStyles();
    const {token, setToken} = useToken()
    const dispatch = useDispatch()
    const report = useSelector((state: any) => state.harvest_all_report.reportData);
    const [selectedFromDate, setSelectedFromDate] = React.useState(
        startOfMonth(subMonths(subYears(new Date(),1),1))  );
    const [selectedToDate, setSelectedToDate] = React.useState(
        endOfMonth(new Date())
    );
    
    useEffect(() => {
      dispatch(fetchAll({token}))
    }, [dispatch]);
    
    const runningDates = []
    for (let i=5; i > -1; i--) { 
        let temp = startOfMonth(subMonths(new Date(), i))
        runningDates.push(format(temp, "LLLL-yy"))
    } 
    const harvestList = report.data || []
    
    const crops = [ ...new Set(harvestList.flatMap((harvest)=>{
        return harvest.Crop
    }))];

    const TableCells = () => {
        return runningDates.map((date) => {
            return(
                <TableCell key={date}>{date}</TableCell>
            )
        });
    }

    const DataTableCells = () => {
        let tablerows = []
        crops.forEach((crop) => {
            let tablecells = []
            tablecells.push(crop)
            runningDates.forEach((date) => {
                let notFound = true
                for (let harvest in harvestList) {
                    if (harvestList[harvest].Crop === crop && 
                        harvestList[harvest].Date === date &&
                        harvestList[harvest].Total !== "0") {
                        tablecells.push(harvestList[harvest].Total)
                        break;
                        notFound = false
                    } 
                }
                if (notFound) {
                    tablecells.push(0)
                }
            });
            tablerows.push(tablecells)
        });
        return tablerows
    }
    const rows = DataTableCells();

    return (
    <div style={{ height: 400, width: '100%' }}>
    <Typography variant="h6" className={classes.title}>
        Harvest
    </Typography>
        <TableContainer>
        <Table aria-label="simple table">
        <TableHead>
            <TableRow>
                <TableCell key="kg">(kg)</TableCell>
                <TableCells/>
            </TableRow>
        </TableHead>
        <TableBody>
            { rows.map((row) => (
                <TableRow key={row[0]}>
                    <TableCell>{row[0]}</TableCell>
                    <TableCell>{row[1]}</TableCell>
                    <TableCell>{row[2]}</TableCell>
                    <TableCell>{row[3]}</TableCell>
                    <TableCell>{row[4]}</TableCell>
                    <TableCell>{row[5]}</TableCell>
                    <TableCell>{row[6]}</TableCell>
                </TableRow>
            ))}
        </TableBody>
        </Table>
        </TableContainer>
    </div>
    )
}

export default Harvest
